import React from "react";
const GlobalContext = React.createContext(null);
export default GlobalContext;
